export default "__VITE_ASSET__D131QxxC__"